module.exports = __webpack_public_path__ + "static/media/Youtube.7afb4cec.svg";